module.exports = __webpack_public_path__ + "img/20190629103241QQ截图20190624162206.b5fb53c5.png";